import { HttpParams } from '@angular/common/http';

export function getFilledParams<T>(params?: Record<string, T>): HttpParams {
  let httpParams = new HttpParams();

  if (!params) {
    return httpParams;
  }

  Object.keys(params).forEach((key) => {
    const value = params[key];

    if (value === undefined || value === null || value === '') {
      return;
    }

    if (Array.isArray(value)) {
      if (value.length > 0) {
        value.forEach((item) => {
          const stringifiedItem = typeof item === 'object' ? JSON.stringify(item) : String(item);
          httpParams = httpParams.append(key, stringifiedItem);
        });
      }
    } else {
      const stringifiedValue = typeof value === 'object' ? JSON.stringify(value) : String(value);
      httpParams = httpParams.set(key, stringifiedValue);
    }
  });
  return httpParams;
}
